/*
 * Lib Module Debounce
 *
 * Simplified debouncing function
 * Read more at https://davidwalsh.name/javascript-debounce-function
 *
 * Example:
 *
 * $(window).on('resize', function(){
 *     Lib.Debounce(function(){
 *         console.log('Debounced');
 *     }, 500);
 * });
 *
 * This results in a log message 500ms after the last window.resize
 */

Lib.Debounce = (function () {
    var timer = {};
    return function (callback, ms, identifier = 'default') {
        clearTimeout(timer[identifier]);
        timer[identifier] = setTimeout(callback, ms);
    };
})();
